export default __webpack_public_path__ + "118e39db88c7fd3163a52e234eeb6519.ttf";